/*
  AUKSales redesign (October 2026).
  Each block below is a separate IIFE that finds its own markup and does
  nothing when that markup is absent, so one feature failing cannot stop the
  others. assets/theme.js is deliberately untouched (its product tab parser
  is off limits).
*/

/* -- Storage helper: private windows and blocked storage throw, and the page
      must still render correctly when they do. -- */
var aukStore = {
  get: function (key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  },
  set: function (key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* storage unavailable */ }
  }
};

function aukOnCartOrCheckout() {
  var path = window.location.pathname;
  return /\/cart(\/|$)/.test(path) || /\/checkout/.test(path) || /\/checkouts\//.test(path);
}

/* -- Job 11b: delivery roadmap, in business days, always as a range -- */
(function () {
  var roadmap = document.querySelector('[data-delivery-roadmap]');
  if (!roadmap) return;

  function addBusinessDays(from, days) {
    var date = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    var left = Math.max(0, days);
    while (left > 0) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) left -= 1;
    }
    return date;
  }

  function format(date) {
    return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function range(from, min, max) {
    var start = addBusinessDays(from, min);
    var end = addBusinessDays(from, max);
    if (start.getTime() === end.getTime()) return format(start);
    return format(start) + ' – ' + format(end);
  }

  function number(name, fallback) {
    var value = parseInt(roadmap.getAttribute(name), 10);
    return isNaN(value) ? fallback : value;
  }

  var today = new Date();
  var slots = {
    purchased: format(today),
    processing: range(today, number('data-processing-min', 1), number('data-processing-max', 3)),
    delivered: range(today, number('data-delivery-min', 7), number('data-delivery-max', 10))
  };
  Object.keys(slots).forEach(function (key) {
    var node = roadmap.querySelector('[data-roadmap-date="' + key + '"]');
    if (node) node.textContent = slots[key];
  });
  roadmap.classList.add('has-dates');
})();

/* -- Job 11h: recently viewed, per browser, newest first, capped at 8 -- */
(function () {
  var root = document.querySelector('[data-recently-viewed]');
  if (!root || !window.fetch) return;
  var grid = root.querySelector('[data-recently-viewed-grid]');
  var current = root.getAttribute('data-current-handle');
  var KEY = 'auksales_recently_viewed';
  var list = [];
  try { list = JSON.parse(aukStore.get(KEY) || '[]'); } catch (e) { list = []; }
  if (!Array.isArray(list)) list = [];
  list = list.filter(function (handle) { return typeof handle === 'string' && handle; });

  /* Record this product for the next page, without showing it here. */
  var updated = [current].concat(list.filter(function (handle) { return handle !== current; })).slice(0, 8);
  aukStore.set(KEY, JSON.stringify(updated));

  var toShow = list.filter(function (handle) { return handle !== current; }).slice(0, 4);
  if (!toShow.length || !grid) return;

  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  Promise.all(toShow.map(function (handle) {
    return fetch(base + 'products/' + encodeURIComponent(handle) + '?sections=product-card-render')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) { return data && data['product-card-render'] ? data['product-card-render'] : ''; })
      .catch(function () { return ''; });
  })).then(function (htmls) {
    var holder = document.createElement('div');
    var added = 0;
    htmls.forEach(function (html) {
      if (!html) return;
      holder.innerHTML = html;
      var card = holder.querySelector('.product-card');
      if (!card) return;
      /* Cards are revealed by an observer in theme.js that has already run. */
      card.classList.add('is-visible');
      grid.appendChild(card);
      added += 1;
    });
    if (added > 0) root.hidden = false;
  });
})();

/* -- Job 11i: sticky add-to-cart strip, driving the real product form -- */
(function () {
  var strip = document.querySelector('[data-sticky-atc]');
  var mainButton = document.querySelector('[data-main-atc]');
  if (!strip || !mainButton || !('IntersectionObserver' in window) || aukOnCartOrCheckout()) return;
  var form = mainButton.form;
  var mainQty = form ? form.querySelector('input[name="quantity"]') : null;
  var stickyQty = strip.querySelector('[data-sticky-qty]');
  var stickyButton = strip.querySelector('[data-sticky-submit]');
  if (!form || !stickyButton) return;

  function setVisible(visible) {
    strip.classList.toggle('is-visible', visible);
    strip.setAttribute('aria-hidden', visible ? 'false' : 'true');
    [stickyQty, stickyButton].forEach(function (node) {
      if (node) node.tabIndex = visible ? 0 : -1;
    });
    document.documentElement.classList.toggle('has-sticky-atc', visible);
  }

  /* The header is sticky, so the button is out of sight once it slides
     under the header, not when it leaves the viewport. */
  var header = document.querySelector('.site-header');
  var headerHeight = header ? header.offsetHeight : 0;
  new IntersectionObserver(function (entries) {
    var entry = entries[0];
    /* Only once the real button has scrolled up out of view, not before it. */
    setVisible(!entry.isIntersecting && entry.boundingClientRect.top < headerHeight);
  }, { rootMargin: '-' + headerHeight + 'px 0px 0px 0px' }).observe(mainButton);

  if (mainQty && stickyQty) {
    mainQty.addEventListener('input', function () { stickyQty.value = mainQty.value; });
    stickyQty.addEventListener('input', function () { mainQty.value = stickyQty.value; });
  }

  stickyButton.addEventListener('click', function () {
    if (mainQty && stickyQty) mainQty.value = stickyQty.value;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(mainButton);
    else mainButton.click();
  });
})();

/* -- Job 13: main nav dropdowns (Shop by Category mega menu, Information) -- */
(function () {
  var items = document.querySelectorAll('[data-nav-dropdown]');
  if (!items.length) return;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var usingKeyboard = false;
  document.addEventListener('keydown', function (event) { if (event.key === 'Tab') usingKeyboard = true; });
  document.addEventListener('mousedown', function () { usingKeyboard = false; });
  document.addEventListener('touchstart', function () { usingKeyboard = false; }, { passive: true });

  function setOpen(item, open) {
    var trigger = item.querySelector('.main-nav__trigger');
    if (open && !item.classList.contains('is-open')) item.setAttribute('data-opened-at', String(Date.now()));
    item.classList.toggle('is-open', open);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAll(except) {
    items.forEach(function (item) { if (item !== except) setOpen(item, false); });
  }

  items.forEach(function (item) {
    var trigger = item.querySelector('.main-nav__trigger');
    var hoverTimer;
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      /* With a mouse, hovering already opened the panel a moment ago; the
         click that follows must not immediately close it again. */
      var openedAt = parseInt(item.getAttribute('data-opened-at'), 10) || 0;
      if (canHover && item.classList.contains('is-open') && Date.now() - openedAt < 600) return;
      var open = !item.classList.contains('is-open');
      closeAll(item);
      setOpen(item, open);
    });

    if (canHover) {
      item.addEventListener('mouseenter', function () {
        window.clearTimeout(hoverTimer);
        closeAll(item);
        setOpen(item, true);
      });
      item.addEventListener('mouseleave', function () {
        hoverTimer = window.setTimeout(function () { setOpen(item, false); }, 180);
      });
    }

    item.addEventListener('focusin', function () {
      if (!usingKeyboard) return;
      closeAll(item);
      setOpen(item, true);
    });
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) setOpen(item, false);
    });

    item.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !item.classList.contains('is-open')) return;
      event.stopPropagation();
      setOpen(item, false);
      trigger.focus();
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-nav-dropdown]')) closeAll();
  });
})();

/* -- Job 9: tab title changes while the visitor is away --
   Swaps document.title when the tab is hidden and restores the exact
   original on return. Never on cart or checkout. Restores on
   visibilitychange, focus and pageshow so a back/forward-cache restore
   cannot leave the title stuck. No favicon swap, no sound. */
(function () {
  if (aukOnCartOrCheckout()) return;
  var originalTitle = document.title;
  var awayTitle = '⚡ Come Back !!!';

  function restore() {
    if (document.title === awayTitle) document.title = originalTitle;
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      if (document.title !== awayTitle) originalTitle = document.title;
      document.title = awayTitle;
    } else {
      restore();
    }
  });
  window.addEventListener('focus', restore);
  window.addEventListener('pageshow', restore);
})();

/* -- Job 12b: welcome offer modal --
   Once per visitor (dismissal kept in localStorage, wrapped in try/catch),
   after a delay, never on cart/checkout. Esc closes, focus is trapped while
   open and returned on close. Sets html.welcome-open so a future purchase
   toast can stay hidden while the modal is up. */
(function () {
  var modal = document.querySelector('[data-welcome-modal]');
  if (!modal || aukOnCartOrCheckout()) return;
  var KEY = 'auksales_welcome_seen';
  if (aukStore.get(KEY)) return;
  var dialog = modal.querySelector('[role="dialog"]');
  var lastFocus = null;
  var delay = (parseInt(modal.getAttribute('data-welcome-delay'), 10) || 8) * 1000;

  function focusables() {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (node) { return node.offsetParent !== null; }
    );
  }
  function onKey(event) {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    var nodes = focusables();
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
  function open() {
    /* Do not interrupt a visitor who is already in a drawer or a menu. */
    var root = document.documentElement;
    if (root.classList.contains('menu-open') || root.classList.contains('cart-open')) {
      window.setTimeout(open, 4000);
      return;
    }
    lastFocus = document.activeElement;
    modal.hidden = false;
    root.classList.add('welcome-open');
    aukStore.set(KEY, String(Date.now()));
    document.addEventListener('keydown', onKey);
    dialog.focus();
  }
  function close() {
    modal.hidden = true;
    document.documentElement.classList.remove('welcome-open');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  modal.querySelectorAll('[data-welcome-close]').forEach(function (node) {
    node.addEventListener('click', close);
  });
  var copy = modal.querySelector('[data-welcome-copy]');
  var code = modal.querySelector('[data-welcome-code]');
  if (copy && code) {
    copy.addEventListener('click', function () {
      var text = code.textContent.trim();
      var done = function () { copy.textContent = 'Copied'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () {});
      }
    });
  }
  window.setTimeout(open, delay);
})();

/* -- Cart: every change is live, one request at a time, drawn from the
      server's cart --
   Drives the cart page, the cart drawer, the header count and the product
   page Add to Cart. Rules:
   - Quantity changes and Remove go to /cart/change.js by LINE KEY (never by
     line index), Add to Cart to /cart/add.js.
   - Rapid clicks on one line are collected for 300ms and sent as one change;
     requests run strictly one after another through a single queue, so two
     changes can never race.
   - A line's controls are disabled while its request is in flight.
   - Every number shown afterwards (line totals, subtotal,
     count) comes from the cart JSON Shopify returns; nothing is priced here.
   - If Shopify caps a quantity at the stock it has, or a request fails, the
     line goes back to the server's quantity and says so on that line.
   Without JavaScript the cart page is a plain form (Update Cart) and Add to
   Cart is a normal form post. */
(function () {
  if (!window.fetch || !window.Promise) return;
  var drawer = document.querySelector('[data-cart-drawer]');
  var drawerItems = document.querySelector('[data-cart-items]');
  var pageForm = document.querySelector('[data-cart-page-form]');
  var pageEmpty = document.querySelector('[data-cart-page-empty]');
  var productForm = document.querySelector('form.product-form');
  var moneyFormat = ((drawer && drawer.getAttribute('data-money-format')) || '${{amount}}').replace(/<[^>]*>/g, '');
  var DEBOUNCE = 300;

  function money(cents) {
    var value = (Number(cents) || 0) / 100;
    function fmt(decimals, thousands, point) {
      var parts = value.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(point);
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      if (key === 'amount_no_decimals') return fmt(0, ',', '.');
      if (key === 'amount_with_comma_separator') return fmt(2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return fmt(0, '.', ',');
      return fmt(2, ',', '.');
    });
  }
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[c];
    });
  }

  /* ---- one queue for every cart request ---- */
  var chain = Promise.resolve();
  var busy = 0;
  var idleWaiters = [];
  function enqueue(job) {
    busy += 1;
    var run = chain.then(job);
    chain = run.catch(function () {}).then(function () {
      busy -= 1;
      if (!busy) idleWaiters.splice(0).forEach(function (fn) { fn(); });
    });
    return run;
  }
  function whenIdle(fn) { if (!busy && !Object.keys(timers).length) fn(); else idleWaiters.push(fn); }

  function request(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) {
          var error = new Error(data.description || data.message || 'Request failed');
          error.status = response.status;
          throw error;
        }
        return data;
      });
    });
  }
  function postJson(url, body) {
    return request(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function getCart() { return request('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }); }

  /* ---- drawing the server's cart ---- */
  var confirmed = {};   /* key -> quantity the server last confirmed */
  var pendingQty = {};  /* key -> quantity the shopper has asked for, not yet sent/confirmed */
  var timers = {};

  function linesFor(key) {
    return Array.prototype.filter.call(document.querySelectorAll('[data-cart-line], [data-cart-item]'), function (node) {
      return node.getAttribute('data-line-key') === key;
    });
  }
  function qtyInput(line) { return line.querySelector('[data-cart-line-qty], [data-cart-quantity]'); }
  function setMessage(key, text) {
    linesFor(key).forEach(function (line) {
      var slot = line.querySelector('[data-cart-line-message]');
      if (!slot) return;
      slot.textContent = text || '';
      slot.hidden = !text;
    });
  }
  function setBusy(key, isBusy) {
    linesFor(key).forEach(function (line) {
      line.classList.toggle('is-updating', isBusy);
      line.setAttribute('aria-busy', isBusy ? 'true' : 'false');
      line.querySelectorAll('button, input').forEach(function (control) { control.disabled = isBusy; });
    });
  }

  function drawerLineMarkup(item) {
    var image = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '';
    return '<div class="cart-drawer-item" data-cart-item data-line-key="' + escapeHtml(item.key) + '">' +
      '<a href="' + escapeHtml(item.url) + '" class="cart-drawer-item__image">' + image + '</a>' +
      '<div class="cart-drawer-item__info">' +
        '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
        '<span data-cart-line-price>' + escapeHtml(money(item.final_line_price)) + '</span>' +
        '<div class="quantity-stepper">' +
          '<button type="button" data-cart-decrease aria-label="Decrease quantity">−</button>' +
          '<input type="number" value="' + item.quantity + '" min="0" data-cart-quantity aria-label="Quantity for ' + escapeHtml(item.product_title) + '">' +
          '<button type="button" data-cart-increase aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<button class="cart-remove" type="button" data-cart-remove>Remove</button>' +
        '<p class="cart-line__message" data-cart-line-message role="status" hidden></p>' +
      '</div>' +
    '</div>';
  }

  function render(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var byKey = {};
    cart.items.forEach(function (item) { byKey[item.key] = item; confirmed[item.key] = item.quantity; });
    Object.keys(confirmed).forEach(function (key) { if (!byKey[key]) delete confirmed[key]; });

    document.querySelectorAll('[data-cart-count]').forEach(function (node) { node.textContent = cart.item_count; });

    /* Cart page: update the server-rendered lines in place. */
    if (pageForm) {
      pageForm.querySelectorAll('[data-cart-line]').forEach(function (line) {
        var item = byKey[line.getAttribute('data-line-key')];
        if (!item) { line.remove(); return; }
        var total = line.querySelector('[data-cart-line-total]');
        var unit = line.querySelector('[data-cart-line-unit]');
        if (total) total.textContent = money(item.final_line_price);
        if (unit) unit.textContent = money(item.final_price);
        if (pendingQty[item.key] == null) qtyInput(line).value = item.quantity;
      });
      var subtotal = pageForm.querySelector('[data-cart-page-subtotal]');
      if (subtotal) subtotal.textContent = money(cart.total_price);
      pageForm.hidden = cart.item_count === 0;
      if (pageEmpty) pageEmpty.hidden = cart.item_count !== 0;
    }

    /* Drawer: keep existing lines (and any quantity mid-edit), add new ones,
       drop removed ones, in the server's order. */
    if (drawerItems) {
      var existing = {};
      drawerItems.querySelectorAll('[data-cart-item]').forEach(function (node) { existing[node.getAttribute('data-line-key')] = node; });
      if (!cart.items.length) {
        drawerItems.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a class="button button--primary" href="/collections/all">Continue Shopping</a></div>';
      } else {
        var empty = drawerItems.querySelector('.cart-drawer__empty');
        if (empty) empty.remove();
        cart.items.forEach(function (item) {
          var node = existing[item.key];
          if (!node) {
            var holder = document.createElement('div');
            holder.innerHTML = drawerLineMarkup(item);
            node = holder.firstChild;
          } else {
            var price = node.querySelector('[data-cart-line-price]');
            if (price) price.textContent = money(item.final_line_price);
            if (!node.querySelector('[data-cart-line-message]')) {
              var slot = document.createElement('p');
              slot.className = 'cart-line__message';
              slot.setAttribute('data-cart-line-message', '');
              slot.setAttribute('role', 'status');
              slot.hidden = true;
              node.querySelector('.cart-drawer-item__info').appendChild(slot);
            }
            if (pendingQty[item.key] == null) qtyInput(node).value = item.quantity;
            delete existing[item.key];
          }
          drawerItems.appendChild(node);
        });
        Object.keys(existing).forEach(function (key) { existing[key].remove(); });
      }
      var drawerSubtotal = document.querySelector('[data-cart-subtotal]');
      if (drawerSubtotal) drawerSubtotal.textContent = money(cart.total_price);
    }
  }

  /* ---- changing a line ---- */
  function commit(key) {
    window.clearTimeout(timers[key]);
    delete timers[key];
    var wanted = pendingQty[key];
    if (wanted == null) return;
    setMessage(key, '');
    setBusy(key, true);
    enqueue(function () {
      /* The value may have moved again while this waited in the queue. */
      wanted = pendingQty[key];
      return postJson('/cart/change.js', { id: key, quantity: wanted }).then(function (cart) {
        delete pendingQty[key];
        render(cart);
        var line = cart.items.filter(function (item) { return item.key === key; })[0];
        if (wanted > 0 && line && line.quantity < wanted) {
          setMessage(key, 'Only ' + line.quantity + ' available — quantity set to ' + line.quantity + '.');
        }
      }, function (error) {
        delete pendingQty[key];
        return getCart().then(render, function () {}).then(function () {
          setMessage(key, error.status === 422 && error.message ? error.message : 'That change didn’t go through. Please try again.');
        });
      });
    }).then(function () { setBusy(key, false); }, function () { setBusy(key, false); });
  }

  function ask(key, quantity, immediately) {
    quantity = Math.max(0, parseInt(quantity, 10) || 0);
    pendingQty[key] = quantity;
    linesFor(key).forEach(function (line) { var input = qtyInput(line); if (input) input.value = quantity; });
    window.clearTimeout(timers[key]);
    if (immediately) { commit(key); return; }
    timers[key] = window.setTimeout(function () { commit(key); }, DEBOUNCE);
  }
  function currentTarget(key) {
    if (pendingQty[key] != null) return pendingQty[key];
    if (confirmed[key] != null) return confirmed[key];
    var line = linesFor(key)[0];
    return line ? parseInt(qtyInput(line).value, 10) || 0 : 0;
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-cart-page-increase], [data-cart-page-decrease], [data-cart-increase], [data-cart-decrease], [data-cart-remove], [data-cart-line-remove]');
    if (!target) return;
    var line = target.closest('[data-cart-line], [data-cart-item]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    event.preventDefault();
    if (line.classList.contains('is-updating')) return;
    if (target.matches('[data-cart-remove], [data-cart-line-remove]')) { ask(key, 0, true); return; }
    var step = target.matches('[data-cart-page-increase], [data-cart-increase]') ? 1 : -1;
    ask(key, currentTarget(key) + step, false);
  });
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-cart-line-qty], [data-cart-quantity]')) return;
    var line = event.target.closest('[data-cart-line], [data-cart-item]');
    if (line) ask(line.getAttribute('data-line-key'), event.target.value, false);
  });

  /* Enter in a quantity field must not fall back to the Update Cart post;
     Checkout waits for any change still on its way. */
  if (pageForm) {
    var checkoutClicked = false;
    pageForm.querySelectorAll('[name="checkout"]').forEach(function (button) {
      button.addEventListener('click', function () { checkoutClicked = true; });
    });
    pageForm.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      var isCheckout = (submitter && submitter.name === 'checkout') || checkoutClicked;
      checkoutClicked = false;
      event.preventDefault();
      if (isCheckout) {
        Object.keys(timers).forEach(commit);
        whenIdle(function () {
          var flag = document.createElement('input');
          flag.type = 'hidden';
          flag.name = 'checkout';
          pageForm.appendChild(flag);
          HTMLFormElement.prototype.submit.call(pageForm);
        });
        return;
      }
      var input = document.activeElement;
      if (input && input.matches && input.matches('[data-cart-line-qty]')) input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  document.querySelectorAll('.cart-drawer__footer form').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!busy && !Object.keys(timers).length) return;
      event.preventDefault();
      Object.keys(timers).forEach(commit);
      whenIdle(function () { HTMLFormElement.prototype.submit.call(form); });
    });
  });

  /* ---- Add to Cart on the product page ---- */
  if (productForm) {
    var addButton = productForm.querySelector('[data-main-atc]');
    var addMessage = document.createElement('p');
    addMessage.className = 'product-form__message';
    addMessage.setAttribute('role', 'status');
    addMessage.hidden = true;
    if (addButton) addButton.insertAdjacentElement('afterend', addMessage);

    productForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!addButton || addButton.disabled) return;
      var data = new FormData(productForm);
      var label = addButton.textContent;
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      addMessage.hidden = true;
      enqueue(function () {
        return request('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
          .then(getCart)
          .then(function (cart) {
            render(cart);
            if (window.AUKTheme && window.AUKTheme.openCart) window.AUKTheme.openCart();
          }, function (error) {
            addMessage.textContent = error.status === 422 && error.message ? error.message : 'Couldn’t add that to your cart. Please try again.';
            addMessage.hidden = false;
            return getCart().then(render, function () {});
          });
      }).then(function () {
        addButton.disabled = false;
        addButton.removeAttribute('aria-busy');
        addButton.textContent = label;
      });
    });
  }

  /* Seed what the server last confirmed, and refresh when the page comes
     back from the back/forward cache with a possibly stale cart. */
  getCart().then(render, function () {});
  window.addEventListener('pageshow', function (event) { if (event.persisted) getCart().then(render, function () {}); });
})();
